import { builder } from '@builder.io/react';

import Header from 'react-scale/components/elements/header';
import Footer from 'react-scale/components/elements/footer';

import Hero from 'react-scale/components/pages/guides/hero/hero-left';
import GuidesList from 'react-scale/components/pages/guides/guides-list';

export default function Guides({ articles }) {
  return (
    <div className="bg-white">
      <Header
        title="Guides | Scale AI"
        canonical="https://scale.com/guides"
        ogImg="https://scale.com/static/images/pages/guides/oxford/fb-guides.png"
        border
        theme="light"
        background="bg-neutral-50"
      />
      <Hero
        title="Guides"
        subtitle="Building AI is difficult, so we have created these guides to help you deliver more business value from your AI investments more quickly."
        theme="light"
      />
      <GuidesList items={articles} />
      <Footer border theme="light" guides={articles.slice(0, 9)} />
    </div>
  );
}

export const getStaticProps = async () => {
  const articles = await builder.getAll('guides-lp', {
    options: { noTargeting: true },
    omit: 'data.blocks',
    limit: 200
  });

  return {
    props: {
      articles: articles ?? []
    }
  };
};

Guides.theme = 'light';
